import { render, staticRenderFns } from "./teacher-icon.vue?vue&type=template&id=674f0383"
import script from "./teacher-icon.vue?vue&type=script&lang=js"
export * from "./teacher-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports